import { TableRow } from '@e2n/ui';
import {
  AbsatzCell,
  InterneNotizCell,
  UmsatzCell,
  WetterCell,
  ZeitpunktCell,
} from './Cells';
import { Data } from '@/domain/controlling/entities/historie';
import { useTagebuchEinstellungen } from '@/domain/controlling/hooks/useTagebuchEinstellungen';
import { useStandortContext } from '@/features/standortContext/StandortContext';

export function HistorieTableRow({
  tagebuchHistorieData,
  type,
}: {
  tagebuchHistorieData: Data | undefined;
  type: 'current' | 'prevWeek' | 'prevMonth' | 'prevYear';
}) {
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { umsatzplanungAnzeige } = useTagebuchEinstellungen(standortId);
  return (
    <TableRow className="hover:bg-transparent">
      <ZeitpunktCell type={type} datum={tagebuchHistorieData?.datum ?? ''} />
      <WetterCell tagebuchData={tagebuchHistorieData} />
      {umsatzplanungAnzeige !== 'ABSATZ_PRODUKTIVITAET' && (
        <UmsatzCell tagebuchData={tagebuchHistorieData} />
      )}
      {umsatzplanungAnzeige !== 'UMSATZ_PRODUKTIVITAET' && (
        <AbsatzCell tagebuchData={tagebuchHistorieData} />
      )}
      <InterneNotizCell tagebuchData={tagebuchHistorieData} />
    </TableRow>
  );
}
